import React from 'react';
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import registerServiceWorker from './registerServiceWorker.js';
import { logger } from 'redux-logger';
import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import reducer from './reducers/index';
import * as signalR from './middlewares/signalRMiddleware';

// all the middlewares
const middleware = [thunk, logger, signalR.signalRMiddleware]
// const middleware = [thunk, signalRMiddleware]
const store = createStore(reducer, applyMiddleware(...middleware))
// register commands for signal r than can be sent to redux store
signalR.signalRRegisterCommands(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>);

// this stuff caches the page which we probably dont need right now
registerServiceWorker();